import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-900-fill",
  "use": "icon-900-fill-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-900-fill\" viewBox=\"0 0 16 16\" id=\"icon-900-fill\">\n  <path d=\"M13.437 1.92h-.5v-.5a.5.5 0 1 0-1 0v.5h-.5a.5.5 0 0 0 0 1h.5v.5a.5.5 0 0 0 1 0v-.5h.5a.5.5 0 0 0 0-1zM9.338 9.092V2.201a2.05 2.05 0 0 0-4.1 0v6.891a3.747 3.747 0 1 0 4.1 0zm-2.03 3.937a1.086 1.086 0 0 1-1.086-1.086 1.075 1.075 0 0 1 .586-.948v-6.47a.5.5 0 0 1 1 0v6.47a1.075 1.075 0 0 1 .586.948 1.086 1.086 0 0 1-1.086 1.086z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol